"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var text_1 = require("../../text");

exports.tableHeaderRowStyle = hs_web_style_guide_1.css({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: colors_1.merino,
  color: colors_1.silverChalice,
  lineHeight: '16px',
  padding: '7px 16px'
});

function BasicTableHeaderRow(props) {
  var children = props.children;
  return React.createElement(text_1.LabelBoldS, __assign({
    className: "basicTableHeaderRow"
  }, exports.tableHeaderRowStyle, props), children);
}

exports.BasicTableHeaderRow = BasicTableHeaderRow;